import { render, staticRenderFns } from "./genbyoutline2.vue?vue&type=template&id=921529f4&scoped=true"
import script from "./genbyoutline2.vue?vue&type=script&lang=js"
export * from "./genbyoutline2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921529f4",
  null
  
)

export default component.exports